export default __webpack_public_path__ + "static/media/canada-flag-1.5x.dde13f91.png";